import { call, select } from 'redux-saga/effects'

import { qrBlobUrlSelector, qrFilenameSelector } from '../selectors'

const initialiseDownload = (href: string, downloadableFilename: string) => {
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', `${downloadableFilename}`)
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export function* downloadQrCodesSaga() {
  const blobUrl = yield select(qrBlobUrlSelector)
  const filename = yield select(qrFilenameSelector)
  yield call(initialiseDownload, blobUrl, filename)
}

export const exportedDownloadForTesting = {
  initialiseDownload,
}
